<template>
  <div class="carousel">
    <img :src="crosshair?.crosshair_image || ''" alt="" class="crosshair-image">
    <Swiper
        :grabCursor="true"
        :loop="false"
        :slides-per-view="1"
        @init="onSwiperInit"
    >
      <SwiperSlide v-for="base in bases" :key="base">
        <div class="item">
          <img :alt="base" :src="`/images/bases/${base}.avif`">
        </div>
      </SwiperSlide>
    </Swiper>
    <div
        :class="{disabled: carousel?.activeIndex === 0}"
        class="carousel-arrow arrow-prev"
        @click="prev"
    >
      <i
          class="i-arrow"
      ></i>
    </div>
    <div
        :class="{disabled: carousel?.isEnd}"
        class="carousel-arrow arrow-next"
        @click="next">
      <i
          class="i-arrow"
      ></i>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {ProPlayerCrosshair} from "~/graphql/generated/schema-types";
import {useResize} from "~/composables/resize";
import type {Swiper as SwiperClass} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/swiper-bundle.css';

const props = defineProps<{
  crosshair: ProPlayerCrosshair
}>()

const currW = useResize()
const {locale} = useI18n()
const bases = ['nuke', 'inferno', 'mirage', 'vertigo', 'dust2', 'ancient']

const toggle = ref(false)
const carousel = ref<SwiperClass | null>(null);


const next = () => {
  if (carousel.value) {
    carousel.value.slideNext();
  }
};

const prev = () => {
  if (carousel.value) {
    carousel.value.slidePrev();
  }
};
const onSwiperInit = (e: any) => {
  if (!carousel.value) {
    carousel.value = e
  }
}
</script>

<style lang="scss" scoped>
@use "/assets/scss/components/carousel";

.carousel {
  display: flex;
  align-items: center;
  min-height: unset;
  height: 132px;
  border-radius: 12px;
  overflow: hidden;

  &:deep(.swiper) {
    height: 100%;
  }

  .crosshair-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    object-fit: cover;
    object-position: center;
    z-index: 5;
    pointer-events: none;
  }

  .item {
    position: relative;
    height: 100%;


    img {
      width: 100%;
      height: 100%;
      object-position: center;
      object-fit: cover;
    }
  }

  .carousel-arrow {
    opacity: 1;
    cursor: pointer;
    background: transparent;

    .i-arrow {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 12px;
    }

    &.disabled {
      .i-arrow {
        color: #8E9EBD;
      }

      cursor: default;
    }

    &.arrow-next {
      right: 16px;
    }

    &.arrow-prev {
      left: 16px;
    }
  }
}
</style>
